import React from 'react'

const Files = () => {
  return (
    <div>
      <p>files</p>
    </div>
  )
}

export default Files
